import React, { createContext, useContext, useEffect, useState } from 'react'
import { mainNotificationContext } from '../context/main-notification-context'
import { useTypedTranslation } from '../hooks/use-translation'
import { AssetsService } from '../services/assets.service'
import { AssetsType, MbcData, MitreData } from '../types/assets'
import { safeCalls, handleCallsErrors } from '../helpers/functions'

export const assetsContext = createContext<AssetsType>({} as AssetsType)

/**
 * You can add here various fetchings from server to cache generic assets
 */
export const WithAssetsContext = ({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element | null => {
  const { _t } = useTypedTranslation()
  const mainNotification = useContext(mainNotificationContext)
  const [mitreAttck, setMitreAttck] = useState<MitreData | undefined>()
  const [mitreAtlas, setMitreAtlas] = useState<MitreData | undefined>()
  const [mbc, setMbc] = useState<MbcData | undefined>()
  const [error, setError] = useState('')
  const errorMessages = ['MITRE ATT&CK', 'MITRE ATLAS', 'MBC']

  async function loadAssets() {
    try {
      const [[mitreAttck, mitreAtlas, mbc], errors] = await safeCalls(
        [AssetsService.getMitreAttckData(), AssetsService.getMitreAtlasData(), AssetsService.getMbcData()],
        errorMessages
      )

      setMitreAttck(mitreAttck)
      setMitreAtlas(mitreAtlas)
      setMbc(mbc)

      handleCallsErrors(errors, mainNotification, _t('error-fetching-assets'))
    } catch (error: any) {
      setError(error.message)
    }
  }

  useEffect(() => {
    loadAssets()
  }, [])

  useEffect(() => {
    error && mainNotification.setMessageData(_t('mitre-or-mbc-load-failed'), 'danger')
  }, [error])

  const provided: AssetsType = {
    mitreAttck: mitreAttck,
    mitreAtlas: mitreAtlas,
    mbc: mbc,
  }

  return <assetsContext.Provider value={provided}>{children}</assetsContext.Provider>
}
